<template>
  <div class="back">
    <div class="icon" @click="back">
      <i class="iconfont icon-arrow-down"></i>
    </div>
    <h3 class="van-ellipsis">{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: 'back-current',
  props: {
    title: {
      type: String
    },
    type: {
      type: String,
      default: '1'
    },
    defaultBack: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    back() {
      if (this.defaultBack) {
        this.$router.back()
      } else {
        this.$emit('on-back')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.back {
  position: relative;
  width: 100%;
  height: 50px;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: #fff;
  .icon {
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 100%;
    i {
      display: inline-block;
      font-size: 20px;
      font-weight: 700;
      transform: rotate(180deg);
    }
  }
  h3 {
    width: 240px;
    margin: 0 auto;
    line-height: 50px;
    font-size: 17px;
    font-weight: 700;
    text-align: center;
  }
}
</style>
